import { useState } from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { GalleryPreview } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { flattenToAppURL } from '@plone/volto/helpers';
import { defineMessages, useIntl } from 'react-intl';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import config from '@plone/volto/registry';

const messages = defineMessages({
  viewPreview: {
    id: 'gallery_viewPreview',
    defaultMessage: "Vedi l'anteprima di",
  },
});

const PageHeaderGallery = ({ content, reactSlick }) => {
  const Slider = reactSlick.default;
  const intl = useIntl();
  const { page_header_gallery: images } = content;
  const [index, setIndex] = useState(null);
  const Image = config.getComponent({ name: 'Image' }).component;
  const getSettings = (nItems, slideToScroll) => {
    return {
      slidesToShow: nItems < 3 ? nItems : 3,
      slidesToScroll: 0,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: nItems < 3 ? nItems : 3,
            slidesToScroll: nItems < 3 ? nItems : 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 0,
            slidesToScroll: 0,
            initialSlide: 0,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 0,
            slidesToScroll: 0,
          },
        },
      ],
    };
  };

  return (
    <div className="it-carousel-all it-card-bg page-header-gallery">
      <Slider {...getSettings(images.length)}>
        {images.map((item, i) => (
          <div className="it-single-slide-wrapper" key={item['@id']}>
            <figure>
              <a
                href={flattenToAppURL(item.image.scales.large.download)}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIndex(i);
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    setIndex(i);
                  }
                }}
                aria-label={`${intl.formatMessage(messages.viewPreview)} ${
                  item.title
                }`}
              >
                <Image
                  item={item.image}
                  alt={item.title}
                  className="img-fluid"
                  responsive={true}
                />
              </a>
            </figure>
          </div>
        ))}
      </Slider>

      <GalleryPreview
        id={`image-gallery-${content.title}`}
        viewIndex={index}
        setViewIndex={setIndex}
        items={images}
      />
    </div>
  );
};

export default injectLazyLibs(['reactSlick'])(PageHeaderGallery);
